import { queryTourSchedule } from "./queries/queryTourSchedule"
import { queryTourSchedules } from "./queries/queryTourSchedules"
import { typeTourSchedule } from "./tourSchedule"

const tourScheduleSchema = {
  types: [typeTourSchedule],
  resolvers: {
    Query: { ...queryTourSchedule, ...queryTourSchedules },
    Mutation: {},
  },
}

export default tourScheduleSchema
